import { LayerLoader } from './LayerLoader';
import { loadWithProperties } from './defaultLayerLoader';

const VERMONT_RESPONDER_BOUNDARIES_URL =
  'vermont.geocomm.cloud/arcgis/rest/services/vermont/Supplemental/MapServer';
/**
 * We're contractually obligated for this layer to have full opacity. If at some
 * point the default loader stops setting 40% opacity, you can delete this
 * loader!
 */
export const vermontResponderBoundariesLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.gis_service_url.includes(VERMONT_RESPONDER_BOUNDARIES_URL);
  },
  async load(service) {
    const properties = {
      id: service.gisLayerID,
      visible: service.auto_checked || false,
      outFields: ['*'],
    };

    return loadWithProperties(service, properties);
  },
};
